const DynamicEditor = {
    types: {
        basic: {
            backgroundColor: 'SNOW_100',
            textColor: 'INK_400',
            borderColor: 'INK_300',
            hoverBackgroundColor: 'PRIMARY_A200',
            hoverTextColor: 'PRIMARY_600',
            hoverBorderColor: 'PRIMARY_400',
            activeBackgroundColor: 'PRIMARY_A400',
            activeTextColor: 'PRIMARY_500',
            activeBorderColor: 'TRANSPARENT',
        },
        primary: {
            backgroundColor: 'PRIMARY_A200',
            textColor: 'PRIMARY_600',
            borderColor: 'PRIMARY_400',
            hoverBackgroundColor: 'PRIMARY_A400',
            hoverTextColor: 'PRIMARY_500',
            hoverBorderColor: 'TRANSPARENT',
            activeBackgroundColor: 'PRIMARY_A400',
            activeTextColor: 'PRIMARY_500',
            activeBorderColor: 'TRANSPARENT',
        },
    },
    hPadding: {
        XSMALL: '0.25rem',
        SMALL: '0.5rem',
        MEDIUM: '0.75rem',
        LARGE: '1rem',
        XLARGE: '1.5rem',
    },
    wPadding: {
        XSMALL: '0.25rem',
        SMALL: '0.5rem',
        MEDIUM: '0.75rem',
        LARGE: '1rem',
        XLARGE: '1.5rem',
    },
};
export default DynamicEditor;
//# sourceMappingURL=dynamicEditor.js.map